import $ from 'jquery';

/**
 * JS to provide a11y tabbing functionality for vertical tabs within 
 * the FYH dropdown panel
 * 
 */
Foundation.Keyboard.register('tabAccessibility', {
  'ARROW_LEFT': 'previousTabLink',
  'ARROW_RIGHT': 'nextTabLink'
});

const tabActions = {
  nextTabLink: function () {
    var focusedElem = $((document.activeElement));
    /**
    * NOTE: Need to work knowing that we need to handle the VIEW ALL link at the end of the lists
    */
    // Get the focused element's parent
    var focusedElemParent = focusedElem.parent(".header-megamenu-nav-tabs-list-item");

    // Get the correct wrapper around this list
    var wrapper = focusedElem.parents(".header-megamenu-fyh-tabs-wrapper, .header-megamenu-fyh-tabs-content-wrapper");

    // Attempt to get the next sibling of the parent. If null, get the view all at the end instead
    var nextTabTitleOrViewAll = focusedElemParent.next(".header-megamenu-nav-tabs-list-item").length > 0 ? focusedElemParent.next(".header-megamenu-nav-tabs-list-item") : wrapper.find(".view-all");

    if (focusedElem.hasClass("view-all") && wrapper.hasClass("header-megamenu-fyh-tabs-wrapper")) {
      // this is the View All Communities link that is 
      // part of the left header fyh dropdown panel -> set focus to The Shea Difference link
      $(".header-nav-link-sheadifference").focus();
    }
    // Focus on the view all, else focus on child link of the tab
    else if (nextTabTitleOrViewAll.hasClass("view-all")) {
      nextTabTitleOrViewAll.focus();
    }
    else {
      nextTabTitleOrViewAll.find("a").focus();

      // emulate click if this is a tab title so that changing tabs opens their panel
      if (nextTabTitleOrViewAll.hasClass("tabs-title")) {
        nextTabTitleOrViewAll.find("a").trigger("click");
      }
    }


  },
  previousTabLink: function () {
    var focusedElem = $((document.activeElement));

    // Get the focused element's parent
    var focusedElemParent = focusedElem.parent(".header-megamenu-nav-tabs-list-item");

    // Get the previous sibling of the parent
    var previousTabTitle = focusedElemParent.prev(".header-megamenu-nav-tabs-list-item");
    previousTabTitle.find("a").focus();

    // emulate click if this is a tab title so that changing tabs opens their panel
    previousTabTitle.find("a").trigger("click");
  },
  handled: function () {
    //   e.preventDefault();
  }
}

// Listen to key down events within the FYH dropdown markup's list items
$('.header-megamenu-fyh .header-megamenu-nav-tabs-list-item').keydown(function (e) {
  // 9 = Tab Key
  var curElem = $(document.activeElement);
  if (curElem[0].id === "fyh-tabs-view-all" && e.which === 9) {
    // Handle the View All Communties link tab to Shea Difference 
    $(".header-nav-link-sheadifference").focus();
    e.preventDefault();
  }
  else {
    // Handle actions for the menu
    Foundation.Keyboard.handleKey(e, 'tabAccessibility', tabActions);
  }
  
});

// Make sure to reset the active tab to the first item everytime the dropdown show
$("#header-megamenu-fyh").on('show.zf.dropdown', function (ev, $el) {
    $("#header-megamenu-fyh .tabs-title:first").find("a").trigger("click");
});

/**
 * 
 */
$(function(){
  

  // Initi Hide menu for tab controls
  initMenuDropdownCloseOnMenuLinkFocus();

  /* 
  * Closes menu with blur function anytime
  * the user tabs thru the desktop header main nav links
  */
  function initMenuDropdownCloseOnMenuLinkFocus() {
    $(".header-main-nav-menu .header-nav-link").focus(function () {
        $("#header-megamenu-fyh, #header-megamenu-resource-guide, #header-megamenu-shea-difference").removeClass("is-open");
        $(".header-nav-link-fyh, .header-nav-link-resourceguide, .header-nav-link-sheadifference").removeClass("hover");

        // Make the first tab active ready for the next time it opens in the FYH dropdown menu case
        $("#header-megamenu-fyh .tabs-title:first").find("a").trigger("click");
      });
  }
});

$(function(){
  $(".header-nav-link").on("keydown", function( event ){
    if (( event.which == 13 ) || (event.which == 32)) {
      let element = $(this);
      element = "#"+element.attr('id');
      let brother = $(element).next();
      if(brother.length !=0){
        event.preventDefault();
        $(brother).foundation('toggle');
        $(this).unbind(event);

      }    
  }
});

$(function() {
  const ogPath = window.location.pathname;
  let path = ogPath; // returns the full URL
  path = path.replace('/', '');
  path = path.replace('.html', '');
  $('.header-nav-link').each(function() {
    let elem = $(this);
    let href = elem.prop('href');
    if ((ogPath != '/')&&(href != null && href.indexOf(path)> -1)) {
      elem.addClass('is-active');
    }
  });
});
});

// Mobile State & Region Global Filter
// This hidden field is define in _FYHSearchAndMap.cshtml and Set in fyh-drilldown.js
// The value of hfFYHStateRegionFilterWasClicked can be undefine/false/true
$(".fyh-state-filter-mobile").click(function (event) {
    if ($("#hfFYHStateRegionFilterWasClicked").length <= 0 && $("#hfFYHStateRegionFilterWasClicked").val() != "true") {
        window.location = "/new-homes/?state=" + $(this).data("state-filter") + "&region=any&bedrooms=0&bathrooms=0&pricemin=any&pricemax=any";
    }
});
$(".fyh-region-filter-mobile").click(function (event) {
    if ($("#hfFYHStateRegionFilterWasClicked").length <= 0 && $("#hfFYHStateRegionFilterWasClicked").val() != "true") {
        window.location = "/new-homes/?state=" + $(this).data("state-filter") + "&region=" + $(this).data("region-filter") + "&bedrooms=0&bathrooms=0&pricemin=any&pricemax=any";
    }
});